import { useEffect, useState, useRef } from "react";
import { Pencil, Trash2, X, File, List,FileX, Calendar,Funnel,Printer, Upload,TicketCheck } from 'lucide-react';
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import DateRangePicker from "../components/DateRangePicker"; 
import NProgress from "nprogress";
import 'nprogress/nprogress.css';
import FilterBar from "../components/FilterBar";


export default function Ajuan() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("tanggal_final");
  const [order, setOrder] = useState("DESC");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [success, setSuccess] = useState(false);
  const [showUploadTrf, setShowUploadTrf] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filters, setFilters] = useState({
    id_vendor: "",
    id_event: "",
    user_input: "",
    read: "",
    trf: "",
    startDate: "",
    endDate: "",
    type: []
  });

  const typeOptions = ["um", "reimburse", "dp", "pelunasan"];

  const navigate = useNavigate();

  useEffect(() => {
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      navigate("/m/ajuan");
    } else {
      navigate("/");
    }
  }, []);

  const [user, setUser] = useState(null);

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;
  const level = storedUser?.level;

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;

    fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.data);
          console.error(data.data);
        } else {
          console.error(data.message);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  
  const [ShowModalFilterAjuan, setShowModalFilterAjuan] = useState(false);
  const [ShowModalAdvanceFilter, setShowModalAdvanceFilter] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showFilterTanggalExcel, setShowFilterTanggalExcel] = useState(false);

  const tableRef = useRef(null);

  // FETCH
  const fetchData = async (reset = false) => {
    if (loading) return;

    setLoading(true);

    const query = new URLSearchParams({
      page,
      limit,
      search,
      sort,
      order,
      ...filters,
      type: Array.isArray(filters.type) ? filters.type.join(",") : ""
    }).toString();

    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/ajuan?${query}`);

    const json = await res.json();

    setData((prev) => (reset ? json.data : [...prev, ...json.data]));
    setHasMore(json.hasMore)
    setTotal(json.total);
    setLoading(false);
  };

  // FILTER CHANGE
  useEffect(() => {
    setPage(1);
    fetchData(true);
    setData([]);
  }, [search, sort, order, filters]);

  useEffect(() => {
    if (page === 1) return;
    fetchData();
  }, [page]);

  // SCROLL DETECTOR (DALAM DIV)
  const handleScroll = () => {
    const el = tableRef.current;
    if (!el || loading || !hasMore) return;

    const bottom =
      el.scrollHeight - el.scrollTop <= el.clientHeight + 50;

    if (bottom) {
      setPage((prev) => prev + 1);
    }
  };

  const handleSort = (field) => {
    setData([]);
    setPage(1);

    if (sort === field) {
      setOrder(order === "ASC" ? "DESC" : "ASC");
    } else {
      setSort(field);
      setOrder("ASC");
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleEdit = (id) => {
    navigate(`/updateRf/${id}`);
  };

  const handleDelete = async (id) => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`);
    const result = await res.json();
    const note = result.data?.note || "User tidak diketahui";
    
    Swal.fire({
      title: `Yakin hapus ini?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire({
              toast: true,
              position: 'top',
              icon: 'success',
              title: 'Terhapus',
              text: `Ajuan berhasil dihapus`,
              showConfirmButton: false,
              showCloseButton: true, 
            });            
            setPage(1);
            fetchData(true);
          });
      }
    });
  };

  const handleTrf = async (id) => {
    // Ambil data dulu
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`);
    const result = await res.json();
    const note = result.data?.note || result.data?.notes || "Ajuan tidak diketahui";
    const trfValue = parseInt(result.data?.trf ?? 0);
    const trfStatus = trfValue === 1 ? 0 : 1; 

    Swal.fire({
      title: `Ubah Status Transfer?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3c30e9ff',
      cancelButtonColor: '#e9303fff',
      confirmButtonText: 'Ya, sudah',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const now = new Date();
        const offset = 7 * 60; // +7 jam dalam menit
        const localTime = new Date(now.getTime() + offset * 60000);
        const formattedNow = localTime.toISOString().slice(0, 19).replace("T", " ");
        const today = new Date().toISOString().split("T")[0]; 
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ trf: trfStatus, trf_by:email, date_of_trf:formattedNow  }),
        })
          .then((res) => res.json())
          .then(() => {
            setSuccess(`Ajuan ${note} sudah dirubah status transfernya`);
            setTimeout(() => setSuccess(false), 30000);
            setPage(1);
            fetchData(true);
          });
      }
    });
  };

  const handleSubmitExport = (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Pilih tanggal terlebih dahulu!");
      return;
    }
    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    if (!user.email || !user.level) {
        console.error("User tidak ditemukan di localStorage");
        return;
      }

    if (user.level === "admin" || user.level === "finance") {
      window.location.href = `${process.env.REACT_APP_BASE_URL}export/filteredRf?start=${formattedStart}&end=${formattedEnd}`;
    } else {
      window.location.href = `${process.env.REACT_APP_BASE_URL}export/export?start=${formattedStart}&end=${formattedEnd}&user_input=${encodeURIComponent(user.email)}`;
    }
  };

  const handleClearFilter = () => {
    setFilters({
      id_vendor: "",
      id_event: "",
      user_input: "",
      read: "",
      trf: ""
    });

    setPage(1);
    setData([]);
  };

  const isEmpty = Object.values(filters).every(v => !v);

  return (
    <>
    
    <div className="p-4 h-[80vh] bg-white rounded-2xl shadow-lg flex flex-col">
      {success && (
        <div className="mt-2 mb-4 bg-green-100 text-green-800 p-4 rounded shadow transition-all duration-30000 flex justify-between">
          <div className="">
            <h1 className="text-md font-bold"> Berhasil</h1>
            {success}
          </div>
          <button
            onClick={() => setSuccess(null)}
            className="ml-auto text-green-600 hover:text-green-800 transition"
          >
            <X size={16} />
          </button>
        </div>
      )}
      <div className="flex justify-between flex-wrap gap-2 p-4 mb-2 bg-slate-200/50 backdrop-blur-xl text-md rounded-2xl border border-slate-800/50">
        <div className="flex flex-col sm:flex-row gap-2">    
          {(["1", "3", "2"].includes(user?.group_id ?? "")) && (
            <Link
              to="/create"
              className="flex items-center gap-2 border border-rose-700 bg-gradient-to-br from-purple-500 to-pink-500 hover:scale-105 transition-transform  text-white p-2 gap-2 rounded-2xl shadow text-md"
            >
              <File size={16} />
              Buat Form Ajuan 
            </Link>
          )}
          {/* <button type="button"
            onClick={() => setShowModalFilterAjuan(true)}  className="flex items-center bg-blue-600 hover:bg-blue-700 text-white gap-2 px-2 py-2 rounded shadow text-md">
            <Funnel size={16} /> Filter Ajuan
          </button> */}
          {/* <button type="button"
            onClick={() => setShowModalAdvanceFilter(true)}  className="flex items-center bg-gradient-to-bl from-blue-500 to-cyan-500 hover:scale-105 transition-transform text-white gap-2 p-2 rounded-2xl shadow text-md">
            <Funnel size={16} /> Advance Filter
          </button> */}
          {/* <button type="button"
            onClick={() => setShowModal(true)} className="flex items-center border border-rose-700 bg-gradient-to-br from-purple-500 to-pink-500 hover:scale-105 transition-transform  text-white p-2 gap-2 rounded-2xl shadow text-md">
            <Calendar size={16} /> Filter Tanggal
          </button> */}
          {(["1", "2", "3"].includes(user?.group_id ?? "")) && (
            <button type="button"
              onClick={() => setShowFilterTanggalExcel(true)} className="flex items-center border border-green-300 bg-gradient-to-br from-green-500 to-teal-500 hover:scale-105 transition-transform  text-green-700 p-2 gap-2 rounded-2xl shadow text-md text-white ">
              <FileX size={16} /> Export ke Excel
            </button>
          )}
          <FilterBar onChange={setFilters} onClear={handleClearFilter} /> 
          {!isEmpty && (
            <button
              onClick={handleClearFilter}
              className="flex items-center border border-red-300 bg-gradient-to-br from-red-500 to-orange-500 hover:scale-105 transition-transform  text-red-700 p-2 gap-2 rounded-2xl shadow text-md text-white "
            >
              <X size={16}></X> Clear Filter
            </button>
          )}
        </div>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Search..."
            className="border p-2 rounded-2xl"
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/*  CONTAINER TABLE (FIXED HEIGHT) */}    
      <div
        ref={tableRef}
        onScroll={handleScroll}
        className="flex-1 overflow-y-auto 
          bg-white/10 
          backdrop-blur-xl 
          rounded-2xl 
          border border-white/20 
          shadow-2xl shadow-black/20"
      >       
        
        <table className="min-w-full">
          <thead className="sticky top-0 bg-gray-300 z-5">
            <tr className="border-b border-slate-800/50 text-gray-700 uppercase tracking-wider">
              <th onClick={() => handleSort("tanggal_final")} className="py-4 px-4 cursor-pointer text-left">Tanggal</th>
              <th onClick={() => handleSort("vendor")} className="py-2 px-4 cursor-pointer text-left">Keterangan</th>
              <th onClick={() => handleSort("vendor")} className="py-2 px-4 cursor-pointer text-left">Vendor</th>
              <th onClick={() => handleSort("event")} className="py-2 px-4 cursor-pointer text-left">Event</th>
              <th onClick={() => handleSort("pic")} className="py-2 px-4 cursor-pointer text-left">PIC</th>
              <th className="p-2 cursor-pointer text-left">Status</th>
              <th className="py-2 px-4 cursor-pointer text-left">Total</th>
              <th className="py-2 px-4 cursor-pointer text-left">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {data?.map((row) => (
              <tr onClick={() => window.open(`/v3/detail/${row.id}`, "_blank")} key={row.id} className={`group border hover:bg-slate-400/30 transition-all duration-300 shimmer  ${row.read === 'read' ? 'font-medium' : 'font-bold'}`}>
                <td className="py-4 px-4 w-18 lg:w-36">
                  {format(new Date(row.tanggal_final), "dd MMM yyyy")}
                  <br />
                  {format(new Date(row.tanggal_final), "HH:mm:ss")}
                </td>
                <td className="py-4 px-4 w-96 lg:w-128"><p class="break-words leading-relaxed">{row.note}</p></td>
                <td className="py-4 px-4 w-36 lg:w-48">{row.vendor}</td>
                <td className="py-4 px-4 w-18 lg:w-36">{row.event}</td>
                <td className="py-4 px-4 w-36 lg:w-48">{row.pic}</td>
                <td className="py-4 px-2 text-sm">
                  <span className={`px-2 py-1 rounded-full border ${row.trf === "1"
                      ? 'bg-green-100 text-green-700 border-green-800'
                      : row.read === "read"
                        ? 'bg-purple-100 text-purple-700 border-purple-800'
                        : 'bg-red-100 text-red-700 border-red-800'
                  }`}>
                    {
                      row.trf === "1"
                        ? 'Sudah Transfer'
                        : row.read === "read"
                          ? 'Sudah Print'
                          : 'Belum Print'
                    }
                  </span>
                </td>
                <td className="p-4 w-36 lg:w-48">
                  <span
                    className={`px-2 py-1 font-semibold border rounded-full ${
                      row.trf === "1"
                        ? 'bg-green-100 text-green-700 border-green-700'
                        : 'bg-red-100 text-red-700 border-red-700'
                    }`}
                  >
                    {new Intl.NumberFormat('id-ID', {
                      style: 'currency',
                      currency: 'IDR',
                      minimumFractionDigits: 0,
                    }).format(row.total)}
                  </span>
                </td>
                <td class="p-4 w-18 lg:w-36">
                  {["1"].includes(user?.group_id ?? "") && (
                    <div className="gap-1 grid grid-cols-1 md:grid-cols-3">
                      <button
                        className="px-2 py-2 rounded-2xl bg-yellow-500/10 hover:bg-yellow-500/50 hover:text-white text-yellow-400 border border-yellow-500/70 transition-all duration-200 hover:scale-105 text-sm font-medium flex justify-center items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(row.id);
                        }}
                      >
                        <Pencil size={14} />
                      </button>
                      <button
                        className={`px-2 py-2 rounded-2xl hover:text-white border transition-all duration-200 hover:scale-105 text-sm font-medium flex justify-center items-center ${
                          row.trf === "1"
                            ? 'bg-green-500/10 hover:bg-green-500/50 border-green-500/70 text-green-400'
                            : 'bg-purple-500/10 hover:bg-purple-500/50 border-purple-500/70 text-purple-400'
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTrf(row.id);
                        }}
                      >
                        <TicketCheck size={14} />
                      </button>          
                      <button
                        className="px-2 py-2 rounded-2xl hover:text-white border text-red-500 transition-all duration-200 hover:scale-105 text-sm font-medium bg-red-500/10 hover:bg-red-500/50 border-red-500 flex justify-center items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(row.id);
                        }}
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                    )
                  }
                  {["2"].includes(user?.group_id ?? "") && (
                    <div className="gap-1 grid grid-cols-1 md:grid-cols-2">
                      <button
                        className="px-2 py-2 rounded-2xl bg-yellow-500/10 hover:bg-yellow-500/50 hover:text-white text-yellow-400 border border-yellow-500/70 transition-all duration-200 hover:scale-105 text-sm font-medium flex justify-center items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(row.id);
                        }}
                      >
                        <Pencil size={14} />
                      </button>&nbsp;&nbsp;&nbsp;
                      <button
                        className={`px-2 py-2 rounded-2xl hover:text-white border transition-all duration-200 hover:scale-105 text-sm font-medium flex justify-center items-center ${
                          row.trf === 0
                            ? 'bg-green-500/10 hover:bg-green-500/50 border-green-500/70 text-green-400'
                            : 'bg-purple-500/10 hover:bg-purple-500/50 border-purple-500/70 text-purple-400'
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTrf(row.id);
                        }}
                      >
                        <TicketCheck size={14} />
                      </button>
                    </div>
                    )
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <form className="space-y-4">
              <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-md w-full">
                <h3 className="text-lg font-bold mb-4">Filter Tanggal</h3>
  
                {/* Komponen DateRange */}
                <DateRangePicker
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                />
  
                <div className="flex justify-end gap-2 mt-6">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                  >
                    Batal
                  </button>
                  <button
                    onClick={() => {
                      const start = startDate ? format(startDate, "yyyy-MM-dd") : "";
                      const end = endDate ? format(endDate, "yyyy-MM-dd") : "";
                      setShowModal(false);
                      navigate(`/filteredRf?start=${start}&end=${end}`);
                      setShowModal(false);                    
                    }}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                  >
                    Terapkan
                  </button>
                </div>
              </div>
              </form>
          </div>
        )}
        

        {/* ⏳ LOADING */}
        {loading && (
          <div className="p-4 text-center">Loading...</div>
        )}

        {/* 🚫 END */}
        {!hasMore && (
          <div className="p-4 text-center text-gray-500">
            Semua data sudah dimuat
          </div>
        )}
      </div>
      <div className="p-2 text-sm text-gray-500">
        Menampilkan {data.length.toLocaleString('id-ID')} dari Total Ajuan {total.toLocaleString('id-ID')}
      </div>
    </div>
    {showFilterTanggalExcel && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <form className="space-y-4">
              <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-md w-full">
                <h3 className="text-lg font-bold mb-4">Filter Tanggal Export ke Excel</h3>
                {/* Komponen DateRange */}
                <DateRangePicker
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                />
  
                <div className="flex justify-end gap-2 mt-6">
                  <button
                    onClick={() => setShowFilterTanggalExcel(false)}
                    className="bg-gradient-to-br from-gray-300 to-slate-950 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                  >
                    Batal
                  </button>
                  <button
                    onClick={handleSubmitExport}
                    className="bg-gradient-to-br from-cyan-500 to-blue-800 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                  >
                    Terapkan
                  </button>
                </div>
              </div>
              </form>
          </div>
        )}
    </>
  );
}